import {
  Alert,
  Button,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useCreateMerchant } from '../../api/hooks/merchants';
import { Formik } from 'formik';
import { Merchant } from 'src/app/api/openapi';
import { useState } from 'react';

const CreateMerchant = () => {
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState(undefined);

  const { mutate: createMerchant } = useCreateMerchant({
    onSuccess() {
      navigate('/merchants');
    },
    onError(error: any) {
      if (!error) return;
      setErrorMessage(error.response.data.extra[0].message);
    },
  });

  const handleCreateMerchant = (values: Merchant) => {
    createMerchant(values);
  };

  return (
    <Formik
      initialValues={{
        merchant_id: '',
        name: '',
        provider: 'clover',
        address: {
          street_address: '',
          country: '',
          locality: '',
          region: '',
          postal_code: '',
        },
      }}
      onSubmit={handleCreateMerchant}
    >
      {({ submitForm, getFieldProps }) => (
        <>
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="h1">Create Merchant</Typography>
            <Button variant="flat" onClick={submitForm}>
              Create
            </Button>
          </Stack>
          {errorMessage && (
            <Alert severity="error" onClose={() => setErrorMessage(undefined)}>
              {errorMessage}
            </Alert>
          )}
          <Stack component="form" alignItems="center" width="100%">
            <Stack direction="row" width="100%">
              <TextField
                label="Merchant Name"
                {...getFieldProps('name')}
                sx={{ m: 1, width: '100%' }}
              />
            </Stack>
            <Stack direction="row" width="100%">
              <TextField
                label="Merchant ID"
                {...getFieldProps('merchant_id')}
                sx={{ m: 1, width: '100%' }}
              />
              <TextField
                label="Provider"
                select
                {...getFieldProps('provider')}
                sx={{ m: 1, width: '100%' }}
              >
                <MenuItem value="clover">Clover</MenuItem>
              </TextField>
            </Stack>
            <Stack direction="row" width="100%">
              <TextField
                label="Street Address"
                {...getFieldProps('address.street_address')}
                sx={{ m: 1, width: '100%' }}
              />
            </Stack>
            <Stack direction="row" width="100%">
              <TextField
                label="Locality"
                {...getFieldProps('address.locality')}
                sx={{ m: 1, width: '100%' }}
              />
              <TextField
                label="Region"
                {...getFieldProps('address.region')}
                sx={{ m: 1, width: '100%' }}
              />
            </Stack>
            <Stack direction="row" width="100%">
              <TextField
                label="Country"
                {...getFieldProps('address.country')}
                sx={{ m: 1, width: '100%' }}
              />
              <TextField
                label="Postal Code"
                {...getFieldProps('address.postal_code')}
                sx={{ m: 1, width: '100%' }}
              />
            </Stack>
          </Stack>
        </>
      )}
    </Formik>
  );
};

export default CreateMerchant;
